import PropTypes from "prop-types";
import React, { Component } from "react";
import { Trans } from "@lingui/macro";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Button, Dialog, Input, withStyles } from "@material-ui/core";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import { translator } from "../utils/i18n";
import TextField from "@material-ui/core/TextField";
import { Field, reduxForm } from "redux-form";
// import * as ReactGA from "react-ga";
import { KeyboardDatePicker } from "@material-ui/pickers";
import CloseIcon from "@material-ui/icons/Close";
import AddIcon from "@material-ui/icons/Add";
import IconButton from "@material-ui/core/IconButton";
import InputMask from "react-input-mask";

const styles = () => ({
  dialog: {
    maxWidth: "680px",
    width: "680px"
  }
});

const validate = (values, props) => {
  const errors = {};
  var requiredFields = [
    "nom",
    "prenom",
    "civilite",
    "datenaissance",
    "numsecu"
  ];

  if (props.infoNewForm.b_activ_adresse) {
    requiredFields = requiredFields.concat(["address", "codePostal", "ville"]);
  }
  if (props.infoNewForm.b_activ_medecin_traitant) {
    requiredFields = requiredFields.concat(["medecinTraitant"]);
  }

  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = translator()._("W_CE_CHAMP_EST_OBLIGATOIRE");
    }
  });
  return errors;
};

class AddPerson extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      selectedDate: null,
      securityId: "",
      invalidSec: this.props.isRequiredSocialSecurity,
      numSecInit: true
    };

    this.MASK = "9 99 99 99 999 999 99";
    this.today = new Date();
    this.minDate = new Date();
    this.minDate.setFullYear(this.today.getFullYear() - 150);
  }

  handleNumSecu = event => {
    const value = event.target.value.replace(/\s|_/g, "");
    const mask = this.MASK.replace(/\s|_/g, "");
    this.props.change("numsecu", event.target.value);
    if (this.state.numSecInit) {
      this.setState({ numSecInit: false });
    }
    if (!value || value.length !== mask.length) {
      this.setState({ invalidSec: true });
    } else {
      this.setState({ invalidSec: false });
    }
  };

  handleClickOpen = e => {
    e.preventDefault();
    this.props.reset();
    // ReactGA.event({
    //   category: "Ajouter une personne",
    //   action: "Ajouter une personne",
    //   label: "Ajouter une nouvelle personne"
    // });
    this.setState({ open: true, selectedDate: null });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  renderTextField = ({
    label,
    input,
    meta: { touched, invalid, error },
    ...custom
  }) => (
    <TextField
      label={label}
      placeholder={label}
      error={touched && invalid}
      helperText={touched && error}
      {...input}
      {...custom}
    />
  );

  radioButton = ({ input, ...rest }) => (
    <FormControl>
      <RadioGroup {...input} {...rest}>
        <FormControlLabel
          value="1"
          control={<Radio color="primary" />}
          label={translator()._("W_STEP4_CIVILITE_M")}
          className="radio-custom"
        />
        <FormControlLabel
          value="2"
          control={<Radio color="primary" />}
          label={translator()._("W_STEP4_CIVILITE_MME")}
          className="radio-custom"
        />
      </RadioGroup>
    </FormControl>
  );

  handleChangeDob = date => {
    this.setState({ selectedDate: date });

    const formatedDate = date
      ? date.invalid
        ? ""
        : date.day + "/" + date.month + "/" + date.year
      : "";
    this.props.change("datenaissance", formatedDate);
  };

  hiddenInput = () => {
    return <Input name="hidden-input" type="hidden" />;
  };

  render() {
    const {
      classes,
      handleSubmit,
      pristine,
      submitting,
      invalid = true
    } = this.props;
    const initialFocusedDate = new Date();
    initialFocusedDate.setFullYear(initialFocusedDate.getFullYear() - 18);
    const { invalidSec, numSecInit } = this.state;
    return (
      <React.Fragment>
        <Button
          onClick={this.handleClickOpen}
          className="btn-filled"
          startIcon={<AddIcon sx={{ fontSize: 100 }} />}
          color="secondary"
          variant="contained"
          size="large"
        >
          <Trans id="W_STEP_BAS_AJOUTER_UNE_PERSONNE" />
        </Button>

        <Dialog
          aria-labelledby="priority-dialog-title"
          open={this.state.open}
          onClose={this.handleClose}
          classes={{ paper: classes.dialog }}
        >
          <IconButton
            className="close-dialog"
            edge="start"
            color="inherit"
            onClick={this.handleClose}
            aria-label="close"
          >
            <CloseIcon className="white" />
          </IconButton>
          <DialogTitle className="head-dialog" id="priority-dialog-title">
            <div className="title-dialog">
              <i className="material-icons">person_add</i>
              <span className="title-text">
                <Trans id="W_STEP_BAS_AJOUTER_UNE_PERSONNE" />
              </span>
            </div>
          </DialogTitle>
          <div className="body-dialog">
            <div className="confirm">
              <Trans id="W_IDENTITE_PATIENT" />
            </div>
            <form onSubmit={handleSubmit} className="form-add-person">
              <div className="line-form radio-inline">
                <Field name="civilite" component={this.radioButton}>
                  <Radio
                    value="1"
                    label={translator()._("W_STEP4_CIVILITE_M")}
                    color="primary"
                  />
                  <Radio
                    value="2"
                    label={translator()._("W_STEP4_CIVILITE_MME")}
                    color="primary"
                  />
                </Field>
              </div>
              <div className="line-form mt-15">
                <Field
                  name="nom"
                  component={this.renderTextField}
                  label={translator()._("W_STEP4_FORMULAIRE_NOM")}
                  variant="outlined"
                  className="wrap-input-custom"
                />
                <Field
                  name="prenom"
                  component={this.renderTextField}
                  label={translator()._("W_STEP4_FORMULAIRE_PRENOM")}
                  variant="outlined"
                  className="wrap-input-custom"
                />
              </div>
              <div className="line-form mt-20 line-date">
                <div className="item-date">
                  <KeyboardDatePicker
                    className="field-custom-date"
                    value={this.state.selectedDate}
                    placeholder="jj/mm/aaaa"
                    onChange={date => this.handleChangeDob(date)}
                    minDate={this.minDate}
                    maxDate={this.today}
                    format="dd/MM/yyyy"
                    label={translator()._("FORMULAIRE_DATE_DE_NAISSANCE")}
                    inputVariant="outlined"
                    name="dob"
                    disableFuture
                    openTo="year"
                    views={["year", "month", "date"]}
                    okLabel={<Trans id="W_STEP_POPUP_BOUTON_OK" />}
                    cancelLabel={<Trans id="W_ANNULER" />}
                    initialFocusedDate={initialFocusedDate}
                    invalidDateMessage={translator()._("W_DATE_INVALID")}
                    maxDateMessage={translator()._("W_MAX_DATE_MESSAGE")}
                    minDateMessage={translator()._("W_MIN_DATE_ALERT")}
                  />
                  <Field
                    name="datenaissance"
                    type="hidden"
                    component={this.hiddenInput}
                    value="abcd"
                  />
                </div>
                <div>
                  <label className="custom-label">
                    <Trans id="W_STEP_POPUP_FORMULAIRE_LIEN_DE_PARENTE" />
                  </label>
                  <div className="wrap-input">
                    <Field name="parent" component="select" className="select">
                      <option value="autre">
                        {translator()._("W_RELATION_AUTRE")}
                      </option>
                      <option value="pere">
                        {translator()._("W_RELATION_PERE")}
                      </option>
                      <option value="mere">
                        {translator()._("W_RELATION_MERE")}
                      </option>
                      <option value="conjoint">
                        {translator()._("W_RELATION_CONJOINT")}
                      </option>
                      <option value="concubin">
                        {translator()._("W_RELATION_CONCUBIN")}
                      </option>
                      <option value="enfant">
                        {translator()._("W_RELATION_ENFANT")}
                      </option>
                    </Field>
                  </div>
                </div>
              </div>
              {this.props.isRequiredSocialSecurity && (
                <div className="line-form mt-20 mr-0">
                  <InputMask
                    mask={this.MASK}
                    disabled={false}
                    onChange={this.handleNumSecu}
                  >
                    {inputProps => (
                      <TextField
                        {...inputProps}
                        label={translator()._("W_SECURITE_SOCIAL")}
                        variant="outlined"
                        className="wrap-input-custom form-field-person"
                        value={this.props.numsecu}
                        error={!numSecInit && invalidSec}
                        helperText={!numSecInit && invalidSec}
                        name="numsecu"
                      />
                    )}
                  </InputMask>
                </div>
              )}
              {this.props.infoNewForm.b_activ_adresse && (
                <div>
                  <div className="line-form mt-15">
                    <Field
                      name="address"
                      component={this.renderTextField}
                      label={translator()._("W_STEP4_FORMULAIRE_ADRESSE")}
                      variant="outlined"
                      className="wrap-input-custom form-field-person"
                    />
                  </div>
                  <div className="line-form mt-15">
                    <Field
                      name="codePostal"
                      component={this.renderTextField}
                      label={translator()._("W_STEP4_FORMULAIRE_CODE_POSTAL")}
                      variant="outlined"
                      className="wrap-input-custom"
                      onInput={e => {
                        e.target.value = e.target.value
                          .replace(/[a-z]/g, "")
                          .slice(0, 5);
                      }}
                    />
                    <Field
                      name="ville"
                      component={this.renderTextField}
                      label={translator()._("W_STEP4_FORMULAIRE_VILLE")}
                      variant="outlined"
                      className="wrap-input-custom"
                    />
                  </div>
                </div>
              )}
              {this.props.infoNewForm.b_activ_medecin_traitant && (
                <div className="line-form mt-15">
                  <Field
                    name="medecinTraitant"
                    component={this.renderTextField}
                    label={translator()._("W_RELATION_MEDECIN_TRAITANT")}
                    variant="outlined"
                    className="wrap-input-custom form-field-person"
                  />
                </div>
              )}
              <div className="wrap-btns mt-30 display-flex justify-content-center">
                <Button
                  className="btn-filled"
                  type="submit"
                  disabled={invalid || submitting || pristine || invalidSec}
                  onClick={this.handleClose}
                  color="primary"
                  variant="contained"
                >
                  <Trans id="W_STEP_POPUP_AJOUTER_UN_PARTICIPANT" />
                </Button>
              </div>
            </form>
          </div>
        </Dialog>
      </React.Fragment>
    );
  }
}

AddPerson.propTypes = {
  change: PropTypes.func,
  classes: PropTypes.shape({
    dialog: PropTypes.any
  }),
  handleSubmit: PropTypes.any,
  infoNewForm: PropTypes.shape({
    b_activ_adresse: PropTypes.any,
    b_activ_medecin_traitant: PropTypes.any
  }),
  invalid: PropTypes.bool,
  isRequiredSocialSecurity: PropTypes.any,
  numsecu: PropTypes.any,
  pristine: PropTypes.any,
  reset: PropTypes.func,
  submitting: PropTypes.any
};

export default withStyles(styles)(
  reduxForm({
    form: "addPerson",
    validate
  })(AddPerson)
);
